import React from 'react';
import Checkbox from 'jl-design-system/elements/checkbox/Checkbox';
import Tooltip from 'jl-design-system/components/tooltip/Tooltip';

export const MARKETING_PREFERENCES_TOOLTIP_ID = 'marketingPreferencesTooltipId';

export function getMarketingComponent() {
  return (
    <div className="marketing-preferences-link-wrapper">
      <Tooltip
        buttonLabel="What will I receive"
        icon
        id={MARKETING_PREFERENCES_TOOLTIP_ID}
      >
        <p>
          We&apos;ll send you updates on the latest offers and promotional events,
          inspiration and Partner advice, plus invites to in-store events.
        </p>
      </Tooltip>
    </div>
  );
}

export const MARKETING_PREFERENCE_JL = () => ({
  component: Checkbox,
  type: 'checkbox',
  name: 'marketingPreferenceJL',
  label: 'John Lewis',
  id: 'marketingPreferenceJL',
  checkedValue: 'true',
  className: 'fieldInline',
});

export const MARKETING_PREFERENCE_WAITROSE = () => ({
  ...MARKETING_PREFERENCE_JL(),
  name: 'marketingPreferenceWaitrose',
  label: 'Waitrose',
  id: 'marketingPreferenceWaitrose',
});

export const MARKETING_PREFERENCE_FINANCIAL_SERVICES = () => ({
  ...MARKETING_PREFERENCE_JL(),
  name: 'marketingPreferenceFinancialServices',
  label: 'John Lewis Finance',
  id: 'marketingPreferenceFinancialServices',
});

export const MARKETING_PREFERENCES_LINK = {
  component: getMarketingComponent,
  extra: true,
  name: 'marketing_preferences_link ',
};

export const MARKETING_PREFERENCES_FORM_ID = 'marketingPreferencesForm';
export function getMarketingPreferencesFormConfig() {
  return {
    id: MARKETING_PREFERENCES_FORM_ID,
    submitButton: 'Update preferences',
    fields: [
      MARKETING_PREFERENCE_JL(),
      MARKETING_PREFERENCE_WAITROSE(),
      MARKETING_PREFERENCE_FINANCIAL_SERVICES(),
      MARKETING_PREFERENCES_LINK,
    ],
  };
}
